/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutState } from './rolloutState';
import { RolloutVisibility } from './rolloutVisibility';
import { RolloutNotificationSpec } from './rolloutNotificationSpec';
import { RolloutTargetSpec } from './rolloutTargetSpec';
import { RolloutExecutionSpec } from './rolloutExecutionSpec';
import { RolloutActionSpec } from './rolloutActionSpec';
import { RolloutServiceType } from './rolloutServiceType';


export interface RolloutPlanUpdateRequest { 
    /**
     * Name of the rollout.
     */
    name?: string;
    /**
     * Description of the rollout.
     */
    description?: string;
    /**
     * Internal Description of the rollout, which wont be shown to customers.
     */
    internal_description?: string;
    service_type?: RolloutServiceType;
    rollout_visibility?: RolloutVisibility;
    action_spec?: RolloutActionSpec;
    target_spec?: RolloutTargetSpec;
    /**
     * List of notifications spec to be created.
     */
    notification_spec?: Array<RolloutNotificationSpec>;
    rollout_execution_spec?: RolloutExecutionSpec;
    state?: RolloutState;
}
export namespace RolloutPlanUpdateRequest {
}


